import { useGetBlocksQuery } from '../../../services/entities/impl/blfApi/endpoints/blocks';
import { useGetCustomersQuery } from '../../../services/entities/impl/blfApi/endpoints/customers';
import { useGetRanchesQuery } from '../../../services/entities/impl/blfApi/endpoints/ranches';
import { useGetUsersQuery } from '../../../services/entities/impl/blfApi/endpoints/users';

import { OnboardApiDataRaw } from '../context/OnboardContext';

export const useGetOnboardingData = () => {
  const {
    data: customers,
    isLoading: isLoadingCustomers,
    isFetching: isFetchingCustomers,
  } = useGetCustomersQuery();

  const {
    data: ranches,
    isLoading: isLoadingRanches,
    isFetching: isFetchingRanches,
  } = useGetRanchesQuery();

  const {
    data: blocks,
    isLoading: isLoadingBlock,
    isFetching: isFetchingBlocks,
  } = useGetBlocksQuery();

  const {
    data: users,
    isLoading: isLoadingUsers,
    isFetching: isFetchingUsers,
  } = useGetUsersQuery();

  const result: OnboardApiDataRaw = {
    customers,
    isLoadingCustomers: isLoadingCustomers || isFetchingCustomers,
    ranches,
    isLoadingRanches: isLoadingRanches || isFetchingRanches,
    blocks,
    isLoadingBlocks: isLoadingBlock || isFetchingBlocks,
    users,
    isLoadingUsers: isLoadingUsers || isFetchingUsers,
  };

  return result;
};
